import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "./customAxios/Axios";
import { useToast } from "./toast";
import logo from "@/assets/talentick.ai.webp";

const AssessmentSideBar = () => {
	const toast = useToast();

	const navigate = useNavigate();
	const location = useLocation();

	const [lastSwitchTime, setLastSwitchTime] = useState<number>(Date.now());
	const cooldownActive = false;
	const [testCanceled, setTestCanceled] = useState(false); // Test cancellation state
	const pathname = location.pathname;

	const logSwitch = async () => {
		if (cooldownActive || testCanceled) return; // Prevents repeated alerts and API calls after cancellation
		const currentTime = Date.now();
		const timeSinceLastSwitch = currentTime - lastSwitchTime;
		try {
			const response = await api.post("/log_tab_switch", {
				candidate_id: JSON.parse(sessionStorage.getItem("question") || "{}")
					?.candidate_id,
				question_id: JSON.parse(localStorage.getItem("question_id") || "{}"),
				section:
					pathname === "/mcq-main"
						? "TECHNICAL"
						: pathname === "/code"
							? "CODING"
							: "BEHAVIOURAL",
				duration_seconds: Math.max(1, Math.floor(timeSinceLastSwitch / 1000)),
			});
			toast.error({
				title: "Stay on the page",
				description: response.data.on_last_switch
					? "This is your final warning; further tab switches will terminate the assessment."
					: "You are not allowed to switch tabs during the test.",
				duration: 5000,
				open: true,
				status: "error",
			});
			setLastSwitchTime(currentTime);
			if (response.data.terminated) {
				setTestCanceled(true);
				navigate("/assessment-termination");
			}
		} catch (error) {
			console.error("Error logging switch:", error);
		}
	};

	useEffect(() => {
		const handleVisibilityChange = () => {
			if (
				!testCanceled &&
				(document.hidden || document.visibilityState === "hidden")
			) {
				logSwitch();
			}
		};

		const handleBlur = () => {
			if (!testCanceled) {
				logSwitch();
			}
		};

		const handleBackNavigation = (event: any) => {
			event.preventDefault();
			window.history.forward();
		};

		const handleBeforeUnload = (event: BeforeUnloadEvent) => {
			event.preventDefault();
			event.returnValue = "";
		};

		document.addEventListener("visibilitychange", handleVisibilityChange);
		window.addEventListener("blur", handleBlur);
		window.addEventListener("popstate", handleBackNavigation);
		window.addEventListener("beforeunload", handleBeforeUnload);

		return () => {
			document.removeEventListener("visibilitychange", handleVisibilityChange);
			window.removeEventListener("blur", handleBlur);
			window.removeEventListener("popstate", handleBackNavigation);
			window.removeEventListener("beforeunload", handleBeforeUnload);
		};
	}, [lastSwitchTime, pathname, testCanceled]);
	useEffect(() => {
		const handleContextMenu = (event: MouseEvent) => {
			event.preventDefault();
		};

		const handleCopy = (event: ClipboardEvent) => {
			event.preventDefault();
		};

		const handlePaste = (event: ClipboardEvent) => {
			event.preventDefault();
		};

		const handleKeyDown = (event: KeyboardEvent) => {
			if (
				event.ctrlKey &&
				(event.key === "c" || event.key === "v" || event.key === "x")
			) {
				event.preventDefault();
			}
			if (event.ctrlKey && event.shiftKey && event.key === "I") {
				event.preventDefault();
			}
		};

		document.addEventListener("contextmenu", handleContextMenu);
		document.addEventListener("copy", handleCopy);
		document.addEventListener("paste", handlePaste);
		document.addEventListener("keydown", handleKeyDown);

		return () => {
			document.removeEventListener("contextmenu", handleContextMenu);
			document.removeEventListener("copy", handleCopy);
			document.removeEventListener("paste", handlePaste);
			document.removeEventListener("keydown", handleKeyDown);
		};
	}, []);

	useEffect(() => {
		const handleContextMenu = (event: MouseEvent) => {
			event.preventDefault();
		};

		const handleCopy = (event: ClipboardEvent) => {
			event.preventDefault();
		};

		const handlePaste = (event: ClipboardEvent) => {
			event.preventDefault();
		};

		const handleKeyDown = (event: KeyboardEvent) => {
			if (
				event.ctrlKey &&
				(event.key === "c" || event.key === "v" || event.key === "x")
			) {
				event.preventDefault();
			}
			if (event.ctrlKey && event.shiftKey && event.key === "I") {
				event.preventDefault();
			}
		};

		document.addEventListener("contextmenu", handleContextMenu);
		document.addEventListener("copy", handleCopy);
		document.addEventListener("paste", handlePaste);
		document.addEventListener("keydown", handleKeyDown);

		return () => {
			document.removeEventListener("contextmenu", handleContextMenu);
			document.removeEventListener("copy", handleCopy);
			document.removeEventListener("paste", handlePaste);
			document.removeEventListener("keydown", handleKeyDown);
		};
	}, []);
	return (
		<>
			<div className=" flex justify-between items-center px-4 py-2 shadow-md mb-3 h-[10vh]">
				<div>
					<img src={logo} className="w-40 md:w-48" alt="Bluetick Logo" />
				</div>
				<div>
					<div className="flex gap-4 mt-2">
						<h1 className="text-xl font-subheading h-fit my-auto">
							{localStorage.getItem("item")
								? JSON.parse(localStorage.getItem("item")!).candidate_name
								: ""}
						</h1>
						{localStorage.getItem("userSelfie") ? (
							<img
								src={localStorage.getItem("userSelfie")!}
								alt="selfie"
								width={"85px"}
								height={"70px"}
								className="p rounded-md"
							/>
						) : (
							""
						)}
					</div>
				</div>
			</div>
		</>
	);
};

export default AssessmentSideBar;
